<template>
    <div class="right-container">
        <div class="nodata" v-if="empty">暂无记录</div>
        <van-list
            v-else
            v-model="loading"
            :finished="finished"
            finished-text="- 没有更多了 -"
            @load="onLoad"
        >
            <right-item
                v-for="(item, index) in items"
                :key="index"
                :date="item.receiveTime"
                :img="item.smallImage"
                :title="item.title"
                :code="item.code"
                :account="item.account"
                :pwd="item.password"
                :link="item.link"
            />
        </van-list>
    </div>
</template>

<script>
import RightItem from '../../componets/records/rightItem';
import { List } from 'vant';
import appBridge from '@/common/util/appBridge';
import recordsMixin from '@/common/js/mixin';

export default {
    name: 'right',
    components: { RightItem, VanList: List },
    mixins: [recordsMixin],
    data() {
        return {
            items: [],
            loading: false, // loading状态转圈圈
            finished: false, // 数据请求结束，结束会显示没有更多了
            empty: false,
            pageNo: 1,
            pageSize: 10,
            setTitleNum: 0,
            titleBar: {
                fullScreen: 2,
                visible: 1,
                leftView: [
                    {
                        action: 'back',
                        color: '#000000',
                        icon: 'ppdwebui://resource/drawable/nav_back',
                        callback: this.goClose
                    }
                ],
                titleView: {
                    text: '领取记录',
                    color: '#000000'
                },
                rightView: []
            }
        };
    },
    created() {
        if (this.setTitleNum < 6) {
            setInterval(() => {
                this.setTitleNum = this.setTitleNum + 1;
                this.customeTitle(this.titleBar);
            }, 500);
        }
    },
    mounted() {
        let score = localStorage.getItem('KUserTotalScore') || 0;
        this.POINT('h5_element_imp', {
            page: 'super-普惠权益领取记录页',
            tgt_event_id: 'h5_ACT_inclusive_record',
            tgt_name: 'h5-ACT-普惠权益领取记录页',
            param: score
        });
    },
    methods: {
        myTimer() {
            console.log('1212');
            this.customeTitle(this.titleBar);
        },
        isEmpty(val) {
            return val === '' || val === null || val === 'undefined';
        },
        async onLoad() {
            this.loading = true;
            try {
                let { Result, Content } = await this.$http.getreceiverecordlist({
                    pageNo: this.pageNo,
                    pageSize: this.pageSize
                });
                if (Result === 200) {
                    if (
                        this.pageNo === 1 &&
                        (this.isEmpty(Content.receiveRecordList) ||
                            Content.receiveRecordList.length === 0)
                    ) {
                        this.empty = true;
                    }
                    this.pageNo += 1;
                    if (Content.receiveRecordList && Content.receiveRecordList.length >= 10) {
                        this.finished = false;
                    } else {
                        this.finished = true;
                    }
                    this.items.push(...Content.receiveRecordList);
                    this.$nextTick(() => {
                        this.loading = false;
                    });
                }
            } catch (e) {
                this.finished = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.right-container {
    width: 100%;
    min-height: 100vh;
    background: rgba(245, 248, 250, 1);
    padding-top: 6px;
    .nodata {
        margin-top: 342px;
        font-size: 14px;
        // font-family: fzlt;
        color: #9a9eaa;
        text-align: center;
    }
}
</style>
